import { apiClient } from "../API/axiosInstance";
import { logger } from "../utils/logger";

/**
 * Service class for dashboard operations
 */
export class ReportsService {
  static async addReport(
    name,
    schedule_id,
    schedule_time,
    schedule_day,
    devices,
    contacts,
    organisation_id
  ) {
    try {
      if (name === "") {
        return false;
      }
      if (devices.length === 0) {
        return false;
      }

      let data = {
        name: name,
        devices: devices,
        contacts: contacts,
        organisation_id: organisation_id,
        schedule_id: schedule_id,
        schedule_time: schedule_time,
        schedule_day: schedule_day,
      };

      await apiClient.post("/report/", data);
      return true;
    } catch (error) {
      logger.error(error);
      return false;
    }
  }

  static async updateReport(reportId, data) {
    let result = await apiClient.put(`/report/${reportId}`, data);

    if (result) {
      return true;
    } else {
      return false;
    }
  }

  static async deleteReport(reportId) {
    if (!reportId) {
      logger.error("Report delete error: No report ID provided");
      return false;
    }

    try {
      const response = await apiClient.delete(`/report/${reportId}`);
      return response && response.status === 200;
    } catch (error) {
      logger.error("Report delete error:", error);
      return false;
    }
  }

  static async fetchReports(orgID) {
    if (!orgID) {
      return [];
    }

    try {
      const response = await apiClient.get(`/report/organisation/${orgID}`);
      return response.data || [];
    } catch (error) {
      logger.error("Error fetching reports:", error);
      return [];
    }
  }

  static async fetchReport(reportId) {
    if (!reportId) {
      return null;
    }

    try {
      const response = await apiClient.get(`/report/${reportId}`);
      return response.data || null;
    } catch (error) {
      logger.error("Error fetching report:", error);
      return null;
    }
  }

  static async fetchReportFiles(id) {
    if (!id) {
      return [];
    }

    // Fetch report files
    const response = await apiClient.get(`/report/file/${id}`);
    return response.data;
  }
}
